/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Status_RejectedInputs */

const en_us2_board_status_rejected = /** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not published`)
};

const pt_br2_board_status_rejected = /** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não publicada`)
};

const pt_pt2_board_status_rejected = /** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não publicada`)
};

/** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */
const es_419_board_status_rejected = en_us2_board_status_rejected;

/** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */
const fr_fr2_board_status_rejected = en_us2_board_status_rejected;

/** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */
const de_de2_board_status_rejected = en_us2_board_status_rejected;

/** @type {(inputs: Board_Status_RejectedInputs) => LocalizedString} */
const it_it2_board_status_rejected = en_us2_board_status_rejected;

/**
* | output |
* | --- |
* | "Not published" |
*
* @param {Board_Status_RejectedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_status_rejected = /** @type {((inputs?: Board_Status_RejectedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Status_RejectedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_status_rejected(inputs)
	if (locale === "es-419") return es_419_board_status_rejected(inputs)
	if (locale === "pt-PT") return pt_pt2_board_status_rejected(inputs)
	if (locale === "fr-FR") return fr_fr2_board_status_rejected(inputs)
	if (locale === "de-DE") return de_de2_board_status_rejected(inputs)
	if (locale === "it-IT") return it_it2_board_status_rejected(inputs)
	return en_us2_board_status_rejected(inputs)
});
export { board_status_rejected as "board.status_rejected" }